import React, { createContext, useState, useEffect } from 'react';
import { message } from 'antd';
import { login as apiLogin, register as apiRegister } from '../services/auth';

export const AuthContext = createContext();
console.log('AuthContext created:', AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // 检查本地存储中的令牌
  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    console.log('AuthContext初始化:', { token, userData });
    
    if (token && userData) {
      setUser(JSON.parse(userData));
      setIsAuthenticated(true);
      console.log('从本地存储恢复用户会话');
    } else {
      // 临时自动登录功能（仅用于开发测试）
      const tempUser = { id: 1, name: '测试用户', phone: '13800138000' };
      localStorage.setItem('token', 'temp_token_for_development');
      localStorage.setItem('user', JSON.stringify(tempUser));
      setUser(tempUser);
      setIsAuthenticated(true);
      console.log('创建临时用户会话');
    }
    
    setLoading(false);
  }, []);

  // 登录
  const login = async (credentials) => {
    try {
      setLoading(true);
      const response = await apiLogin(credentials);
      
      localStorage.setItem('token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));
      
      setUser(response.user);
      setIsAuthenticated(true);
      message.success('登录成功');
      
      return true;
    } catch (error) {
      message.error(error.message || '登录失败，请检查账号和密码');
      return false;
    } finally {
      setLoading(false);
    }
  };

  // 注册
  const register = async (userData) => {
    try {
      setLoading(true);
      const response = await apiRegister(userData);
      
      localStorage.setItem('token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));
      
      setUser(response.user);
      setIsAuthenticated(true);
      message.success('注册成功');
      
      return true;
    } catch (error) {
      message.error(error.message || '注册失败，请稍后再试');
      return false;
    } finally {
      setLoading(false);
    }
  };

  // 登出
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setIsAuthenticated(false);
    message.success('已退出登录');
  };

  console.log('AuthProvider rendering');

  return (
    <AuthContext.Provider value={{
      user,
      isAuthenticated,
      loading,
      login,
      register,
      logout
    }}>
      {console.log('AuthContext.Provider rendering with value:', { user, isAuthenticated, loading })}
      {children}
    </AuthContext.Provider>
  );
}; 